<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				ref="table"
				class="grid-content"
				:data="tableData"
				border
				stripe
				:height="tableHeight"
				@row-dblclick='rowClick'
			>
				<el-table-column
					label-class-name="column-index"
					label="序号"
					type="index"
					align="center"
					width="50">
				</el-table-column>
				<el-table-column
					prop="shopName"
					label="销售门店"
					align="center">
				</el-table-column>
				<el-table-column
					prop="productName"
					label="商品名称/编号"
					align="center"
					min-width="120">
					<template slot-scope="scope">
						<div>{{scope.row.productName}}</div>
						<div class="text-code">{{scope.row.productCode}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="productAttrplanName"
					label="规格名称/编号"
					align="center"
					min-width="120">
					<template slot-scope="scope">
						<div>{{scope.row.productAttrplanName}}</div>
						<div class="text-code">{{scope.row.productAttrplanCode}}</div>
					</template>
				</el-table-column>
				<!-- <el-table-column
					prop="outStockQuantity"
					label="出库数量"
					align="center">
				</el-table-column>
				<el-table-column
					prop="outStockTotalMoney"
					label="出库金额"
					align="center">
				</el-table-column>
				<el-table-column
					prop="inStockQuantity"
					label="入库数量"
					align="center">
				</el-table-column>
				<el-table-column
					prop="inStockTotalMoney"
					label="入库金额"
					align="center">
				</el-table-column> -->
				<el-table-column
					prop="inventory"
					label="可售库存"
					align="center">
					<template slot="header">
						<div class="title-box">可售库存
							<el-tooltip class="item" effect="dark" content="买家小程序中显示的库存数量" placement="top-start">
								<img src="~/images/icon/tooltip-icon.png" class="spec-title">
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="150" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="refreshOpen(scope.row.rpasId)">刷新库存</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20, 40, 60, 100, 300]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
		<el-dialog title="刷新库存" style="text-align:left" :visible.sync="refreshModel" width='520px' :close-on-click-modal="false">
			<div>
				刷新库存开始时间: <el-date-picker
						v-model="dateValue"
						:clearable="false"
						size="small"
						placeholder="选择日期时间"
						type="datetime"
						format='yyyy-MM-dd HH:mm'
						value-format='yyyy-MM-dd HH:mm'>
					</el-date-picker> ~ 至今
			</div>
			<div class="refresh-button"><el-button type="primary" size="medium" @click="refreshInventory">立即刷新</el-button></div>
			<div style="color:red">刷新速度与查询时间相关，查询时间越长，刷新速度越长，建议您选择该商品需刷新库存的实际开始时间，请耐心等待</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		AuthorityList: {
			type: Object
		},
		sumInStockProductQuantity: Number,
		sumInStockTotalMoney: String,
		sumOutStockProductQuantity: Number,
		sumOutStockTotalMoney: String
	},
	data () {
		return {
			AuthorityList1: {
				'13_0001_0001_00': false
			},
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			},
			refreshModel: false,
			dateValue: '',
			rpasId: ''
		}
	},
	watch: {
		tableData: {
			handler (val) {
				this.$nextTick(() => {
					this.$refs['table'].doLayout()
				})
			}
		}
	},
	created () {
		this.getAuthority('13_0001_0000_00')
	},
	methods: {
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList1[a[i]] = true
					}
				}
			})
		},
		refreshOpen (id) {
			this.rpasId = id
			this.refreshModel = true
		},
		refreshInventory () {
			if (!this.dateValue) {
				this.$message.error('请选择刷新库存开始时间')
				return false
			}
			let params = {
				rpasId: this.rpasId,
				refreshDate: this.dateValue + ':00'
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQNVShop}/stock/inventoryrefresh`,
				data: params
			}).then(res => {
				if (res.result) {
					this.refreshModel = false
					setTimeout(() => {
						this.$emit('modifySuc')
					}, 1000)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		getSummaries (param) {
			const { columns, data } = param
			const sums = []
			console.log(columns, data)
			columns.forEach((column, index) => {
				// console.log(column, index)
				sums[index] = ''
				if (index === 1) {
					sums[index] = '搜索结果合计:'
					// return
				}
				if (index === 4) {
					sums[index] = this.sumOutStockProductQuantity
					// return
				}
				if (index === 5) {
					sums[index] = this.sumOutStockTotalMoney + '元'
					// return
				}
				if (index === 6) {
					sums[index] = this.sumInStockProductQuantity
					// return
				}
				if (index === 7) {
					sums[index] = this.sumInStockTotalMoney + '元'
					// return
				}
			})
			return sums
		},
		rowClick (row, column, event) {
			if (this.AuthorityList1['13_0001_0001_00']) {
				this.$router.push({ path: '/main/storage', name: 'storage', params: { id: row.productAttrplanId } })
			}
		},
		// 跳订单
		goOrderDetail (row) {
			let orderParams = {}
			orderParams.orderId = row.orderid
			orderParams.statusId = row.statusId
			orderParams.differ = row.differ
			orderParams.buypullstate = row.buypullstate
			switch (row.orderStatus) {
			case 0:
				orderParams.billState = '待付款'
				break
			case 1:
				orderParams.billState = '待接单'
				break
			case 2:
				orderParams.billState = '待发货'
				break
			case 3:
				orderParams.billState = '待收货'
				break
			case 4:
				orderParams.billState = '已完成'
				break
			case 5:
				orderParams.billState = '已取消'
				break
			}
			window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
			let tabInfo = {}
			tabInfo.active = orderParams.billState
			tabInfo.isSellerpull = false
			tabInfo.orderStatus = row.orderStatus
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabInfo))
			this.$fxGoBlank('/blankdetail', this.$router)
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		},
		// 勾销
		liquidate (row, type) {
			let params = {
				liquidateflag: type,
				commissionResultIds: row.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/result/liquidateflag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.$emit('modifySuc')
				} else {
					this.$message.error('勾销失败，请稍后重试')
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.main-table-box {
		flex: 1
		width: 100%
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
		.text-code {
			color: #999;
			font-size:12px
		}
		// .el-table{
		// 	overflow:visible !important;
		// }
	}
}
</style>
<style lang="stylus">
.under-num {
	cursor :pointer;
	color: var(--fx-primary-color);
	display: flex;
	justify-content: center;
	align-items: center;
}
.main-table {
	// .el-table{
	// 	overflow:visible !important;
	// }
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
	.under-num1 {
		color: var(--fx-primary-color);
		display: flex;
		align-items: center;
		span {
			cursor :pointer;
		}
		.return-icon {
			margin-left :5px;
			font-size :10px;
			width: 20px;
			height: 18px;
			line-height: 16px;
			color :#EC4141;
			border :1px solid #EC4141;
			border-radius :5px;
			flex-shrink: 0
		}
	}
	.title-box {
		display: flex;
		justify-content: center;
		align-items: center;
		.spec-title {
			width: 14px;
			height: 14px;
			cursor: pointer;
			margin: -1px 0 0 4px;
		}
	}
	.refresh-button {
		text-align: center;
		margin: 50px 0 30px;
	}
}
</style>
